
export const getSpaDeviceInfo = () => {
  return {
    deviceTypeId: 'A3OEMT9S4WNMK',
  }
}

